import React, { useEffect, useState } from 'react';
import { httpService } from '../../services/http.service';
import { API_ENDPOINTS } from '../../config/api.config';
import StepSectionSelector from '../../Components/StepSectionSelector';

const SectionContent = ({ projectId, currentStep, handleSelectionChange, getAllSelectedElements }) => {
  const [sections, setSections] = useState([]);
  const [stepContents, setStepContents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSectionsData = async () => {
      if (!projectId || !currentStep?.id) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);

        const projectData = await httpService.get(API_ENDPOINTS.PROJECTS.DETAIL(projectId));

        if (projectData && projectData.steps) {
          const currentStepData = projectData.steps.find(step => step.id === currentStep.id);
          
          if (currentStepData && currentStepData.sections) {
            setSections(currentStepData.sections);

            let allContents = [];
            currentStepData.sections.forEach(section => {
              if (section.contents && Array.isArray(section.contents)) {
                section.contents.forEach(content => {
                  allContents.push({
                    ...content,
                    step_id: currentStep.id,
                    section_id: section.id
                  });
                });
              }
            });
            setStepContents(allContents);
          } else {
            setSections([]);
            setStepContents([]);
          }
        } else {
          setSections([]);
          setStepContents([]);
        }
      } catch (err) {
        setError(err.message || 'Erreur lors du chargement des sections');
      } finally {
        setIsLoading(false);
      }
    };

    fetchSectionsData();
  }, [projectId, currentStep?.id]);

  if (isLoading) {
    return (
      <div className="text-center p-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
        <p className="mt-2">Chargement des sections...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        <i className="fas fa-exclamation-triangle me-2"></i>
        Erreur : {error}
      </div>
    );
  }

  // Transformer le tableau plat de `getAllSelectedElements` en l'objet attendu par StepSectionSelector
  const selectedElementsForSelector = getAllSelectedElements().reduce((acc, element) => {
    // On ne garde que les sélections de l'étape actuelle
    if (element.stepId === currentStep.id) {
      // La clé est l'ID du contenu (element.id)
      acc[element.id] = element;
    }
    return acc;
  }, {});


  return (
    <div className="section-content">
      <StepSectionSelector
        sections={sections}
        contents={stepContents}
        onSelectionChange={handleSelectionChange}
        selectedElements={selectedElementsForSelector}
      />
    </div>
  );
};

export default SectionContent;
